import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { getTicketFields } from 'components/Filter/TicketFields'
import { links } from 'utils/featureToggles'

import Tickets from './Tickets/Tickets'
import { ticketsSalesColumns } from './ticketsSalesColumn'
import { TicketsViewType } from './TicketsViewType'

const TicketsSales = (): JSX.Element => (
  <React.Fragment>
    <Breadcrumbs crumbs={[{ title: 'Sales Tickets', link: links.ticketsSales.url }]} />
    <Tickets
      viewType={TicketsViewType.Sales}
      columns={ticketsSalesColumns()}
      filterFields={getTicketFields}
    />
  </React.Fragment>
)

export default TicketsSales
